<template>
  <v-card>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title :class="`${arabic ? 'arFont' : 'enFont'}`">
        {{ i18n["list_of_invoices_by_country"] }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-show="!isMobile" class="header">
        <v-card class="px-3 py-3 secondary lighten-1">
          <span :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["total"] }}: {{ invoicesData.total }}$</span>
        </v-card>
        <v-card class="px-3 py-3 secondary lighten-1">
          <span :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["total_orders"] }}: {{ invoicesData.total_count }}</span>
        </v-card>
      </div>
    </v-toolbar>

    <v-tabs v-model="tab" show-arrows vertical active-class="active">
      <v-tab v-for="(invoice, i) in invoicesData.invoices" :key="invoice.label" class="justify-start"
        style="min-width: unset;">
        <img width="30px" style="filter:drop-shadow(2px 2px 4px rgb(0 0 0 / 38%));"
          :src="`/flags/${invoice.label.toLowerCase()}.png`" alt="">
        <span :class="`${arabic ? 'arFont' : 'enFont'} ${tab === i ? 'primary--text' : 'black--text'} pr-2`"
          v-show="!isMobile">
          {{ getCountryLabel(invoice.label) }}
        </span>
      </v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(invoice, i) in invoicesData.invoices" :key="invoice.label" class="justify-start">
          <v-container fluid>
            <v-row no-gutters class="justify-center">
              <v-col lg="2" md="3" xs="12" cols="12" class="pa-3" v-for="(fee, f) in Object.keys(invoice.invoice)"
                :key="fee">
                <v-card class="statCard">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12" class="pt-0">
                        <v-row class="align-center">
                          <v-col cols="12" FIELD>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="d-flex py-1">
                                  <!-- <v-icon size="20" class="black--text px-2">local_shipping</v-icon> -->
                                  <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`" v-bind="attrs" v-on="on">
                                    {{ i18n[fee] }}
                                  </div>
                                </div>
                              </template>
                              <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                                {{ i18n[fee] }}
                              </div>
                            </v-tooltip>
                            <v-row>
                              <v-col class="my-0 py-0">
                                <v-card color="grey lighten-2" class="text-center py-3 mt-3" flat>
                                  <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                                    {{ i18n["usd"] }}
                                  </div>
                                  <div class="mt-1 statValue">
                                    {{ invoice.invoice[fee] }}
                                  </div>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>

    </v-tabs>
  </v-card>
</template>

<script>
export default {
  props: ['invoicesData'],
  data() {
    return {
      tab: 0,
      
      
    };
  },
  computed: {
    countries_() {
      return this.$store.state.countries_
    },
    language() {
      return this.$store.state.language
    },
    globalLoading() {
      return this.$store.state.globalLoading
    },
    user() {
      return this.$store.state.user
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    activeCountryLabel() {
      const activeCountry = this.invoicesData.invoices[this.tab]
      const countryCode = activeCountry.label.toLowerCase()

      return this.countries_[this.language][countryCode]
    },
    activeCountyStats() {
      const activeCountry = this.invoicesData.invoices[this.tab]

      return { count: activeCountry.count, total: activeCountry.total }
    }
  },
  methods: {
    getCountryLabel(code) {
      let countryCode = code.toLowerCase()
      return this.countries_[this.language][countryCode]
    }
  }
};
</script>

<style>
.header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.statCard {
  border-top: solid 5px #9f0019 !important;
  border-bottom: solid 3px #9f0019 !important;
}
</style>
